import React from 'react';
import PropTypes from 'prop-types';
import { Typo } from '@ers/ui';
import cx from 'classnames';
import BaseAvatar from './BaseAvatar';
import Types from './AvatarTypes';


const MessageAvatar = ({ children, visible }) => (
    <BaseAvatar type={Types.Message} text={children} className={cx({ 'avatar--hidden': !visible })}>
        { (initials) => (<Typo.Avatar.Message>{initials}</Typo.Avatar.Message>)}
    </BaseAvatar>
);


MessageAvatar.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    visible: PropTypes.bool.isRequired
};

export default MessageAvatar;